import React from 'react';

export default function OneNightButton() {
  return (
    <button class='flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-64 fb-entity-config-id-30281 fb-domain-go.theflybook.com fb-protocol-https flybook'>
      BOOK NOW
    </button>
  );
}
